import React from 'react';

export default function Spinner({ label }) {
  return (
    <div className="loading-block">
      <span className="spinner" />
      {label && <span>{label}</span>}
    </div>
  );
}
